import type { RookieMilestone } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import { RookieMemberEntity } from "@/modules/boxDashboard/modules/RookieMembers/entities/rookieMemberEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useQuery } from "@tanstack/react-query"

export const ROOKIE_MEMBERS_QUERY_KEY = ["rookieMembers"]
export const ROOKIE_MEMBERS_PAGE_SIZE = 10

export function useRookieMembers(milestone?: RookieMilestone, page = 0, pageSize = ROOKIE_MEMBERS_PAGE_SIZE) {
  const { boxDashboardApi } = useServicesContext()

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: [...ROOKIE_MEMBERS_QUERY_KEY, milestone, page, pageSize],
    queryFn: async () => {
      const dto = await boxDashboardApi.getRookieMembers(milestone, page, pageSize)
      return {
        members: dto.content.map((member) => RookieMemberEntity.fromDto(member)),
        totalCount: dto.totalElements,
        totalPages: dto.totalPages,
        currentPage: dto.page,
      }
    },
    staleTime: 0,
    gcTime: 0,
  })

  return {
    members: data?.members ?? [],
    totalCount: data?.totalCount ?? 0,
    totalPages: data?.totalPages ?? 0,
    currentPage: data?.currentPage ?? 0,
    hasMore: data ? data.currentPage < data.totalPages - 1 : false,
    isLoading,
    isFetching,
    error,
    refetch,
  }
}

export function useTotalRookies() {
  const { boxDashboardApi } = useServicesContext()

  const { data, isLoading, error } = useQuery({
    queryKey: ["totalRookies"],
    queryFn: async () => {
      const dto = await boxDashboardApi.getTotalRookies()
      return dto.total
    },
  })

  return {
    total: data ?? 0,
    isLoading,
    error,
  }
}
